'use client';

import { type TimeScalar } from '@bts-web/utils-formatting';
import { convertToLocaleDateString } from '@bts-web/utils-formatting-client';
import {
  interpolateTranslation,
  useClientLocale,
} from '@bts-web/utils-lokalise';
import { css } from '@bts-web/utils-style-engine';
import { FC } from 'react';

export const UnstakeStartedAtText: FC<{
  startDate: TimeScalar | null | undefined;
  template: string;
}> = ({ startDate, template }) => {
  const locale = useClientLocale();

  return (
    <span
      className={css({
        display: 'flex',
        color: 'neutrals.fill_primary',
        alignItems: 'center',
      })}
    >
      {interpolateTranslation(template, {
        date: convertToLocaleDateString(startDate, locale),
      })}
    </span>
  );
};
